import React from 'react'
import OrderSuccess from '../components/OrderSuccess/Success'

const OrderSuccessPage = () => {
  return (
    <>
        <OrderSuccess />
    </>
  )
}

export default OrderSuccessPage
